// Cashfree Payment Configuration (frontend uses backend-issued payment links)
export const CASHFREE_CONFIG = {
  mode: 'production'
};

// Subscription pricing
export const SUBSCRIPTION_PRICES = {
  base: 999, // Base price ₹999
  gst: 0.18 // 18% GST
};

// Calculate total price with GST
export const calculateTotalPrice = (basePrice = SUBSCRIPTION_PRICES.base) => {
  const gstAmount = basePrice * SUBSCRIPTION_PRICES.gst;
  return {
    basePrice,
    gstAmount,
    totalPrice: basePrice + gstAmount
  };
}; 